import { PageHeader } from '@ant-design/pro-layout';
import { Button, Popconfirm, Space } from 'antd';
import Title from 'antd/es/typography/Title';
import { FC } from 'react';

interface ReIndexSearchCollectionProps {
  handleReIndexUserCollection: () => void;
  reindexUserCollectionLoading: boolean;

  handleReIndexCaseCollection: () => void;
  reindexCaseCollectionLoading: boolean;

  handleReIndexEntityCollection: () => void;
  reindexEntityCollectionLoading: boolean;

  handleReIndexIdCaseCollection: () => void;
  reindexIdCaseCollectionLoading: boolean;

  handleReIndexCredCaseCollection: () => void;
  reindexCredCaseCollectionLoading: boolean;

  handleReIndexSendReportCaseCollection: () => void;
  reindexSendReportCaseCollectionLoading: boolean;
}

const getReindexConfirmationMessage = (collectionName: string) =>
  `This will temporarily bring down the search feature on the ${collectionName} collection for a while. Are you sure you want to do that?`;

export const ReindexSearchCollection: FC<ReIndexSearchCollectionProps> = (props) => {
  const isAnyReindexingLoading =
    props.reindexUserCollectionLoading ||
    props.reindexCaseCollectionLoading ||
    props.reindexEntityCollectionLoading ||
    props.reindexIdCaseCollectionLoading ||
    props.reindexCredCaseCollectionLoading ||
    props.reindexSendReportCaseCollectionLoading;

  return (
    <>
      <PageHeader>
        <div id="leftTitle" style={{ marginBottom: '30px' }}>
          <Title level={3} style={{ display: 'inline' }}>
            Search Indexes
          </Title>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <Title level={4} type="secondary" style={{ display: 'inline' }}>
            Settings
          </Title>
        </div>
      </PageHeader>
      <div style={{ width: '100%', textAlign: 'center' }}>
        <Space direction="horizontal" size={'large'}>
          <Popconfirm
            title="Re-index User collection"
            description={getReindexConfirmationMessage('User')}
            okText="Confirm"
            cancelText="Cancel"
            onConfirm={props.handleReIndexUserCollection}
            overlayInnerStyle={{ width: '400px' }}
          >
            <Button
              type="primary"
              style={{ height: '100px' }}
              loading={props.reindexUserCollectionLoading}
              disabled={isAnyReindexingLoading && !props.reindexUserCollectionLoading}
            >
              Re-index User collection
            </Button>
          </Popconfirm>

          <Popconfirm
            overlayInnerStyle={{ width: '400px' }}
            title="Re-index Case collection"
            description={getReindexConfirmationMessage('Case')}
            okText="Confirm"
            cancelText="Cancel"
            onConfirm={props.handleReIndexCaseCollection}
          >
            <Button
              type="primary"
              style={{ height: '100px' }}
              loading={props.reindexCaseCollectionLoading}
              disabled={isAnyReindexingLoading && !props.reindexCaseCollectionLoading}
            >
              Re-index Case collection
            </Button>
          </Popconfirm>

          <Popconfirm
            overlayInnerStyle={{ width: '400px' }}
            title="Re-index Entity collection"
            description={getReindexConfirmationMessage('Entity')}
            okText="Confirm"
            cancelText="Cancel"
            onConfirm={props.handleReIndexEntityCollection}
          >
            <Button
              type="primary"
              style={{ height: '100px' }}
              loading={props.reindexEntityCollectionLoading}
              disabled={isAnyReindexingLoading && !props.reindexEntityCollectionLoading}
            >
              Re-index Entity collection
            </Button>
          </Popconfirm>
        </Space>
        <div style={{ marginBottom: '2rem' }} />
        <Space direction="horizontal" size={'large'}>
          <Popconfirm
            overlayInnerStyle={{ width: '400px' }}
            title="Re-index ID Case collection"
            description={getReindexConfirmationMessage('ID Case')}
            okText="Confirm"
            cancelText="Cancel"
            onConfirm={props.handleReIndexIdCaseCollection}
          >
            <Button
              type="primary"
              style={{ height: '100px', width: '200px' }}
              loading={props.reindexIdCaseCollectionLoading}
              disabled={isAnyReindexingLoading && !props.reindexIdCaseCollectionLoading}
            >
              Re-index ID Case collection
            </Button>
          </Popconfirm>
          <Popconfirm
            overlayInnerStyle={{ width: '400px' }}
            title="Re-index Cred Case collection"
            description={getReindexConfirmationMessage('Cred Case')}
            okText="Confirm"
            cancelText="Cancel"
            onConfirm={props.handleReIndexCredCaseCollection}
          >
            <Button
              type="primary"
              style={{ height: '100px', width: '220px' }}
              loading={props.reindexCredCaseCollectionLoading}
              disabled={isAnyReindexingLoading && !props.reindexCredCaseCollectionLoading}
            >
              Re-index Cred Case collection
            </Button>
          </Popconfirm>
          <Popconfirm
            overlayInnerStyle={{ width: '400px' }}
            title="Re-index Send Report Case collection"
            description={getReindexConfirmationMessage('Send Report Case')}
            okText="Confirm"
            cancelText="Cancel"
            onConfirm={props.handleReIndexSendReportCaseCollection}
          >
            <Button
              type="primary"
              style={{ height: '100px', width: '270px' }}
              loading={props.reindexSendReportCaseCollectionLoading}
              disabled={isAnyReindexingLoading && !props.reindexSendReportCaseCollectionLoading}
            >
              Re-index Send Report Case collection
            </Button>
          </Popconfirm>
        </Space>
      </div>
    </>
  );
};
